'use client';

import { useRouter, useSearchParams } from 'next/navigation';
import { toast } from 'react-toastify';

import { WithdrawPlayerForm } from '@/components/forms/modals/WitdhdrawPlayerForm';
import { ModalWrapper } from '@/components/organisms';
import { EditRegistrationData } from '@/entities/EditOrganizationModalSchemeData';
import { useTeamLeagueInfo } from '@/hooks/custom-hooks/useTeamLeagueInfo';
import { withDrawPlayerFromLeague } from '@/services/actions/league/withdrawPlayer';
import { useOrganizationStore } from '@/store/organization-store';

interface WithdrawPlayerModalProps {
	onClose: () => void;
}

export const WithdrawPlayerModal = ({ onClose }: WithdrawPlayerModalProps) => {
	const router = useRouter();
	const searchParams = useSearchParams();
	const organizationStore = useOrganizationStore();
	const teamLeagueInfo = useTeamLeagueInfo();

	const handleFormSubmit = async (data: EditRegistrationData) => {
		try {
			const result = await withDrawPlayerFromLeague({
				organizationUuid: organizationStore.organizationUuid,
				teamLeagueUuid: organizationStore.teamLeagueUuid,
				seasonUuid: searchParams.get('season') || teamLeagueInfo.seasonUuid,
				comments: data.comment
			});

			if (result.data?.success) {
				toast.success('You’ve successfully submitted your withdrawal request.');
				router.refresh();
			} else {
				toast.error(result.data?.error?.message ?? 'We couldn’t submit your withdrawal. Please try again later.');
			}

			onClose();
		} catch {
			toast.error('Unexpected error during withdrawal');
		}
	};

	return (
		<ModalWrapper className="!max-w-[475px] !gap-0" title="Withdraw from league" onClose={onClose} closeOnOutsideClick>
			<p className="font-medium py-4">
				By clicking Confirm below, you understand that you are withdrawing your registration from this league. You will be subject to the
				cancellation and refund policy set by the league.
			</p>
			<p className="font-medium">Someone from the league will review this and contact you shortly.</p>
			<WithdrawPlayerForm onSubmit={handleFormSubmit} onClose={onClose} />
		</ModalWrapper>
	);
};
